// 重命名提交的字段名
/* eslint-disable */
export const renamePostParams = (dispatchInfo, formData, name) => {
  if (name === 'dispatch') {
    dispatchInfo[name] = formData[name] || '';
    delete dispatchInfo['dispatchInfo.' + name];
  }
  if (name === 'chooseVehicle' || name === 'contractChart' || name === 'intelligence') {
    // 车辆信息
    for (let sName in formData[name]) {
      if (formData[name][sName]) {
        dispatchInfo['dispatchInfo.' + sName] = formData[name][sName];
      }
    }
  }
  if (name === 'chooseDriver') {
    dispatchInfo['dispatchInfo.carDriverMan'] = formData[name].linkman || '';
    dispatchInfo['dispatchInfo.carDriverId'] = formData[name].userId || '';
    dispatchInfo['dispatchInfo.carDriverPhone'] = formData[name].loginAcct || '';
  }
  if (name === 'chooseCopilotDriver') {
    dispatchInfo['dispatchInfo.copilotMan'] = formData[name].linkman || '';
    dispatchInfo['dispatchInfo.copilotUserId'] = formData[name].userId || '';
    dispatchInfo['dispatchInfo.copilotPhone'] = formData[name].loginAcct || '';
  }
  if (name === 'dispatchTrailerInfo') {
    dispatchInfo['dispatchInfo.trailerId'] = formData[name].trailerId || '';
    dispatchInfo['dispatchInfo.trailerPlate'] = formData[name].trailerNumber || '';
  }
  if (name === 'oilBalance') {
    // 当前重置金额
    dispatchInfo['dispatchInfo.chargeVirtualOilCard.balance'] = formData.sBeforeBalance;
    dispatchInfo['dispatchInfo.chargeVirtualOilCard.beforeBalance'] = formData.sInputOilBalance;
  }
  if (name === 'oilcardList') {
    let oilCardArray = [];
    if (formData.oilcardList.length) {
      for (let item of formData.oilcardList) {
        oilCardArray.push(`${item.cardNum},${item.cardBalanceAdd || '0'},${item.cardType},${item.isAdd || true}`);
      }
    }
    dispatchInfo['dispatchInfo.oilCardStr'] = oilCardArray.join(';');
  }
};
/* eslint-enable */

// 删除多余的字段
export const deleteUnwantParams = (dispatchInfo) => {
  delete dispatchInfo['dispatchInfo.chooseVehicle'];
  delete dispatchInfo['dispatchInfo.chooseDriver'];
  delete dispatchInfo['dispatchInfo.chooseCopilotDriver'];
  delete dispatchInfo['dispatchInfo.dispatchTrailerInfo'];
  delete dispatchInfo['dispatchInfo.oilBalance'];
  delete dispatchInfo['dispatchInfo.selectedCarInfo'];
  delete dispatchInfo['dispatchInfo.oilcardList'];
  delete dispatchInfo['dispatchInfo.sInputOilBalance'];
  delete dispatchInfo['dispatchInfo.driverOilForPayWay'];
  delete dispatchInfo['dispatchInfo.lineInfo'];
  delete dispatchInfo['dispatchInfo.contractChart'];
  delete dispatchInfo['dispatchInfo.intelligence'];
  delete dispatchInfo['dispatchInfo.receiverUserInfo'];
  delete dispatchInfo['dispatchInfo.oilInfo'];
  delete dispatchInfo['dispatchInfo.customerInfo'];
  delete dispatchInfo['dispatchInfo.localUserInfo'];
};
